module.exports = __webpack_public_path__ + "static/media/quick_patient.2666564b.png";